import React, { useState } from "react";
import StockManagement from "./StockManagement";
import BannerManagement from "./BannerManagement";

const AdminDashboard = () => {
  const [view, setView] = useState("stock"); // 'stock' or 'banner'

  return (
    <div style={{ padding: "20px" }}>
      <h1 style={{ textAlign: "center", marginBottom: "20px" }}>后台管理</h1>

      {/* Toggle Buttons */}
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px", gap: "10px" }}>
        <button
          onClick={() => setView("stock")}
          style={{
            padding: "10px 20px",
            backgroundColor: view === "stock" ? "#007bff" : "#ccc",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          }}
        >
          管理库存
        </button>

        <button
          onClick={() => setView("banner")}
          style={{
            padding: "10px 20px",
            backgroundColor: view === "banner" ? "#007bff" : "#ccc",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          }}
        >
          管理横幅
        </button>
      </div>

      {/* Conditional Render */}
      {view === "stock" ? <StockManagement /> : <BannerManagement />}
    </div>
  );
};

export default AdminDashboard;
